import axios from "@/plugins/axios";

export default {
    findById(callCampaignId) {
        return axios.httpApi.get("/call_campaign/" + callCampaignId);
    },
    list(active = true) {
        
        let params = {}

        params.active = active
        params.limit = 9999
        return axios.httpApi.get("/call_campaign", { params });
    },
}